import React, { useState } from 'react';
import '../catalogue/styles.css';
import {
    Input,
    InputGroup,
    Button,
    Nav,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Placeholder,
    Container,
    Col,
    Row,
    Checkbox,
    Modal,
    useToaster,
    Uploader,
    Message,
    Loader
} from 'rsuite';




const Controls = () => {
    const [activeKey, setActiveKey] = useState('content1');
    const handleNavSelect = (eventKey) => {
        setActiveKey(eventKey);
    };


    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Controls</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                                <Breadcrumb.Item active>Controls</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                        <Nav appearance="tabs" activeKey={activeKey} onSelect={handleNavSelect} style={{ gap: '20px' }}>
                            <Nav.Item eventKey="content1"><b>Product</b></Nav.Item>
                            <Nav.Item eventKey="content2"><b>Catalogue</b></Nav.Item>
                        </Nav>
                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row">
                    <Panel>
                        {activeKey === 'content1' && (
                            <>
                            <Stack direction='column' alignItems='flex-start'>
                               <Checkbox defaultChecked><b> Variant</b></Checkbox>
                               <Checkbox defaultChecked><b> Packaging</b></Checkbox>    
                               <Checkbox defaultChecked><b> Costing</b></Checkbox>       
                               </Stack>
                            </>
                        )}
                        {activeKey === 'content2' && (
                            <>
                            <Stack justifyContent='space-around' > 
                            <Stack direction='column' alignItems='flex-start'>
                                <h6>Catalogue</h6>
                               <Checkbox defaultChecked><b> Create Catalogue</b></Checkbox>
                               <Checkbox defaultChecked><b> Draft Catalogue</b></Checkbox>    
                               <Checkbox defaultChecked><b> Final Catalogue</b></Checkbox>       
                               </Stack>
                               <Stack direction='column' alignItems='flex-start'>
                                <h6>Catalogue Format</h6>
                               <Checkbox defaultChecked><b> PPT</b></Checkbox>
                               <Checkbox defaultChecked><b> EXCEL</b></Checkbox>    
                               <Checkbox defaultChecked><b> PDF</b></Checkbox>       
                               </Stack>
                               <Stack direction='column' alignItems='flex-start'>
                                <h6>Share by</h6>
                               <Checkbox defaultChecked><b> Direct Download</b></Checkbox>
                               <Checkbox defaultChecked><b> Email</b></Checkbox>    
                               <Checkbox defaultChecked><b> Whatsapp</b></Checkbox>       
                               </Stack>
                               <Stack direction='column' alignItems='flex-start'>
                                <h6>Link Setting</h6>
                               <Checkbox defaultChecked><b> Pass Code</b></Checkbox> 
                               <Checkbox defaultChecked><b> Email Required</b></Checkbox>    
                               <Checkbox defaultChecked><b> Link Expire on</b></Checkbox>     
                               <Checkbox defaultChecked><b> Can Download PPT</b></Checkbox>    
                               </Stack>
                               </Stack>
                            </>
                        )}

                    </Panel>

                </div>
                <Stack className="copyright"    justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERP Daddy Softwere Solution.</a></p>
                </Stack>
            </Container>
        </>
    );
};
export default Controls;
